import styled from 'styled-components';
import { BHS_PRETO, BHS_VERDE, ESTADO_ERRO } from 'constants/cores';

export const PoliceFormWrapper = styled.div`
  display: grid;
  gap: 16px;

  header {
    width: 100%;
    padding: 0 32px;
    display: flex;
    align-items: center;
    justify-content: space-between;

    strong {
      color: ${BHS_PRETO};
      font-size: 18px;
      font-weight: bold;
      line-height: 26px;
    }
  }

  > div {
    width: 100%;
    padding: 32px;
    display: grid;
    gap: 32px;

    background-color: #fff;
    border-radius: 8px;
    box-shadow: 0 9px 24px rgba(29, 37, 44, .15);

    label {
      position: relative;

      display: flex;
      align-items: center;
      gap: 16px;
      cursor: pointer;

      input {
        border-color: ${BHS_VERDE};
      }

      span {
        color: ${BHS_PRETO};
        font-size: 12px;
      }

      .policesError {
        position: absolute;
        top: calc(100% + 4px);

        color: ${ESTADO_ERRO};
      }
    }
  }
`;


